export default __webpack_public_path__ + "static/share-group-53464c3363087096dde917d237326b51.png";